import { alpha } from '@mui/material/styles';

/**
 * Main content area behind the route shell (radial washes matching Activity page).
 */
export function getUserDashboardMainSx(theme, drawerWidthPx) {
  return {
    flexGrow: 1,
    width: { xs: '100%', sm: `calc(100% - ${drawerWidthPx}px)` },
    minHeight: '100vh',
    position: 'relative',
    overflowX: 'hidden',
    bgcolor: 'background.default',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background: `radial-gradient(ellipse 90% 55% at 50% -15%, ${alpha(theme.palette.primary.main, 0.22)}, transparent 55%),
        radial-gradient(ellipse 55% 45% at 100% 10%, ${alpha(theme.palette.secondary.main, 0.12)}, transparent 50%),
        radial-gradient(ellipse 50% 40% at 0% 30%, ${alpha(theme.palette.primary.main, 0.08)}, transparent 45%),
        radial-gradient(circle at 20% 85%, ${alpha(theme.palette.primary.main, 0.08)} 0%, transparent 45%),
        radial-gradient(circle at 85% 25%, ${alpha(theme.palette.secondary.main, 0.08)} 0%, transparent 45%)`,
      pointerEvents: 'none',
      zIndex: 0,
    },
  };
}

/** Frosted panel wrapping all dashboard routes */
export function getUserDashboardContentShellSx(theme) {
  return {
    position: 'relative',
    zIndex: 1,
    borderRadius: 3,
    border: '1px solid',
    borderColor: alpha(theme.palette.divider, 0.9),
    background: alpha(
      theme.palette.background.paper,
      theme.palette.mode === 'dark' ? 0.55 : 0.92
    ),
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    boxShadow:
      theme.palette.mode === 'dark'
        ? `0 8px 40px ${alpha('#000', 0.35)}, inset 0 1px 0 ${alpha('#fff', 0.06)}`
        : `0 8px 32px ${alpha(theme.palette.primary.main, 0.08)}`,
    overflow: 'hidden',
    minHeight: { xs: 'calc(100vh - 56px - 24px)', sm: 'calc(100vh - 64px - 40px)' },
  };
}

/** Inner cards on dashboard pages (softer lift, works inside shell) */
export function getDashboardCardSx(theme, overrides = {}) {
  return {
    borderRadius: 3,
    border: '1px solid',
    borderColor: alpha(theme.palette.divider, 0.85),
    bgcolor: alpha(
      theme.palette.background.paper,
      theme.palette.mode === 'dark' ? 0.4 : 0.75
    ),
    backdropFilter: 'blur(8px)',
    boxShadow:
      theme.palette.mode === 'dark'
        ? `0 6px 28px ${alpha('#000', 0.22)}`
        : `0 6px 24px ${alpha(theme.palette.primary.main, 0.07)}`,
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease',
    ...overrides,
  };
}
